export * from "./isUUID";
